import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multimedia-gallery-modal',
  templateUrl: './multimedia-gallery-modal.component.html',
  styleUrls: ['./multimedia-gallery-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultimediaGalleryModalComponent implements OnInit {
  @Input() mediaItems: any[] = [];
  @Input() startIndex: number = 0;
  
  @Input() showThumbnails = false;
  currentIndex: number = 0;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.currentIndex = this.startIndex;
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'ArrowRight') {
      this.next();
    } else if (event.key === 'ArrowLeft') {
      this.prev();
    } else if (event.key === 'Escape') {
      this.activeModal.dismiss();
    }
  }

  next() {
    if (this.mediaItems.length <= 1) return;
    this.currentIndex = (this.currentIndex + 1) % this.mediaItems.length;
  }

  prev() {
    if (this.mediaItems.length <= 1) return;
    this.currentIndex = (this.currentIndex - 1 + this.mediaItems.length) % this.mediaItems.length;
  }

  get currentItem() {
    return this.mediaItems[this.currentIndex];
  }

  get isImage(): boolean {
    const url = this.currentItem?.url || this.currentItem?.value || '';
    if (!url) return false;
    const extension = url.split('?')[0].split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    return imageExtensions.includes(extension || '');
  }
}
